// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Positioning the toggle container */
.beta-toggle-container {
    display: flex;
    justify-content: flex-end; /* Align items to the right */
    align-items: center;
    gap: 8px;
    position: relative;
}

/* Ensure tooltip appears above info icon */
.info-container {
    position: relative;
}

/* Remove box around the info icon */
.beta-info-icon {
    cursor: pointer;
    font-size: 16px;
    color: #144040;
    transition: color 0.2s ease-in-out;
}

/* Hover effect */
.beta-info-icon:hover {
    color: #0d2e2e;
}

/* Tooltip */
.tooltip {
    position: absolute;
    bottom: 130%; /* Moves it directly above the icon */
    left: 50%;
    transform: translateX(-50%);
    width: 220px;
    background: #144040;
    color: #fff;
    text-align: left;
    border-radius: 4px;
    padding: 6px 10px;
    z-index: 10;
    font-size: 0.75rem;
    line-height: 1.2;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
    animation: fadeIn 0.2s ease-in-out;
}

/* Tooltip Arrow */
.tooltip::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 6px;
    border-style: solid;
    border-color: #144040 transparent transparent transparent;
}

/* Tooltip fade-in effect */
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateX(-50%) translateY(5px);
    }
    to {
        opacity: 1;
        transform: translateX(-50%);
    }
}
`, "",{"version":3,"sources":["webpack://./src/5D-Thinking/BetaToggle.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;IACI,aAAa;IACb,yBAAyB,EAAE,6BAA6B;IACxD,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;;AAEA,2CAA2C;AAC3C;IACI,kBAAkB;AACtB;;AAEA,oCAAoC;AACpC;IACI,eAAe;IACf,eAAe;IACf,cAAc;IACd,kCAAkC;AACtC;;AAEA,iBAAiB;AACjB;IACI,cAAc;AAClB;;AAEA,YAAY;AACZ;IACI,kBAAkB;IAClB,YAAY,EAAE,qCAAqC;IACnD,SAAS;IACT,2BAA2B;IAC3B,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,0CAA0C;IAC1C,kCAAkC;AACtC;;AAEA,kBAAkB;AAClB;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,iBAAiB;IACjB,mBAAmB;IACnB,yDAAyD;AAC7D;;AAEA,2BAA2B;AAC3B;IACI;QACI,UAAU;QACV,2CAA2C;IAC/C;IACA;QACI,UAAU;QACV,2BAA2B;IAC/B;AACJ","sourcesContent":["/* Positioning the toggle container */\n.beta-toggle-container {\n    display: flex;\n    justify-content: flex-end; /* Align items to the right */\n    align-items: center;\n    gap: 8px;\n    position: relative;\n}\n\n/* Ensure tooltip appears above info icon */\n.info-container {\n    position: relative;\n}\n\n/* Remove box around the info icon */\n.beta-info-icon {\n    cursor: pointer;\n    font-size: 16px;\n    color: #144040;\n    transition: color 0.2s ease-in-out;\n}\n\n/* Hover effect */\n.beta-info-icon:hover {\n    color: #0d2e2e;\n}\n\n/* Tooltip */\n.tooltip {\n    position: absolute;\n    bottom: 130%; /* Moves it directly above the icon */\n    left: 50%;\n    transform: translateX(-50%);\n    width: 220px;\n    background: #144040;\n    color: #fff;\n    text-align: left;\n    border-radius: 4px;\n    padding: 6px 10px;\n    z-index: 10;\n    font-size: 0.75rem;\n    line-height: 1.2;\n    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);\n    animation: fadeIn 0.2s ease-in-out;\n}\n\n/* Tooltip Arrow */\n.tooltip::after {\n    content: \"\";\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    border-width: 6px;\n    border-style: solid;\n    border-color: #144040 transparent transparent transparent;\n}\n\n/* Tooltip fade-in effect */\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: translateX(-50%) translateY(5px);\n    }\n    to {\n        opacity: 1;\n        transform: translateX(-50%);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
